import { render } from "./SectionAbout.vue?vue&type=template&id=06644adc&scoped=true"
import script from "./SectionAbout.vue?vue&type=script&lang=js"
export * from "./SectionAbout.vue?vue&type=script&lang=js"

import "./SectionAbout.vue?vue&type=style&index=0&id=06644adc&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06644adc"]])

export default __exports__